import ApiService from '../_helper/api.service';
import CORSService from '../_helper/cors.service';
import LandingApiResources from '../../constants/api/resources/landing';

const BookingService = {
  createBooking(data: any) {
    return ApiService.post(LandingApiResources.createBooking, data);
  },
  rejectBookingRequest(id: any) {
    const config = { params: { request_hid: id } };
    return ApiService.delete(LandingApiResources.rejectBookingRequest, config);
  },
  authorizeCharge(data: any) {
    return ApiService.post(LandingApiResources.authorizeCharge, data);
  },
  passwordInputScreenGMO(url: string, data: any) {
    return CORSService.post(url, data);
  },
};

export default BookingService;
